import {PAGE_OPT, SEARCH_OPT} from "../../news/config/NewsConfig.js";
import {rendererPageInfo} from "../../util/Page.js";
import * as UIUtil from "../../util/UI.js";
import {getNews, getNewsList} from "../api/NewsApi.js";
import * as _NewsDetail from "./NewsDetail.js";
import {getActiveMenuKey, getKeyMenuByParent, getParentKey, openMenu} from "../../common/Menu.js";

const PAGE = PAGE_OPT.LIST;
const SEARCH = SEARCH_OPT.LIST;
let fullNewsList = [];

export const open = async function (pushHistory = true) {
    try {

        // 히스토리 업데이트 (목록으로 돌아올 때)
        if (pushHistory && location.hash !== '#News') {
            history.pushState({ menuKey: 'News' }, '', '#News');
        }

        document.querySelector(".banner")?.remove();
        document.querySelector("section.contents-wrap")?.remove();

        const lang = document.documentElement.lang || 'ko';
        const htmlUrl = `app/html/${lang}/prcenter/News.html`;

        const headerWrap = document.querySelector(".headerWrap");
        if (!headerWrap) {
            console.error('[News] headerWrap not found');
            return;
        }

        const response = await fetch(htmlUrl);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const html = await response.text();

        headerWrap.insertAdjacentHTML("afterend", html);

        initEvent();
        initSearchEvent();

        await drawList();


    } catch (error) {
        console.error(error);
    }
};

const initEvent = function () {
    const homeElement = document.querySelector('.breadcrumb .home');
    const parentElement = document.querySelectorAll('.breadcrumb li a')[1];

    if (homeElement) {
        homeElement.addEventListener('click', () => {
            openMenu('Main');
        });
    }

    if (parentElement) {
        parentElement.addEventListener('click', () => {
            const currentMenuKey = getActiveMenuKey();
            const parentKey = getParentKey(currentMenuKey);
            const firstChildKey = getKeyMenuByParent(parentKey);
            if (firstChildKey) {
                openMenu(firstChildKey);
            }
        });
    }
}
const drawList = async function (pageNo = 1) {
    PAGE.pageNo = pageNo;

    const param = {
        ...SEARCH,
        rowSize: PAGE.pg_rowsize,
        currentPage: PAGE.pageNo
    };

    const response = await getNewsList(param);

    if (!response.SUCCESS) {
        UIUtil.msgBox("검색 실패", "error");
        return;
    }

    const { LIST, TOTAL_COUNT } = response.RESULT;
    fullNewsList = LIST;

    drawListItems(LIST);
    drawTotalCount(TOTAL_COUNT);
    const pageOption = {
        ...PAGE,
        domId: ".paginate",
        pdom: ".paginate-wrap",
        totalCount: TOTAL_COUNT
    };

    rendererPageInfo(pageOption, drawList);
};

const drawListItems = function (items) {
    const listEl = document.querySelector(".grid-layout-area.news"); // ✅ 정확한 대상
    if (!listEl) return;

    listEl.innerHTML = ""; //

    if (items.length === 0) {
        listEl.innerHTML = `<div class="empty">등록된 보도자료가 없습니다.</div>`;
        return;
    }

    items.forEach((item) => {
        const imageUrl = `/news/file/view/${item.newsImgId}`// fallback 처리
        const a = document.createElement("a");
        // a.href = `/news/${item.newsId}`;
        a.className = "box";

        a.innerHTML = `
            <div class="img-cnt">
                <img src="${imageUrl}" alt="보도자료 이미지">
            </div>
            <div class="tit-cnt">
                <div class="cte-cnt">
                    <span class="category">보도자료</span>
                    <span class="date">${item.registerDate}</span>
                </div>
                <div class="tit">${item.title}</div>
            </div>
        `;
        a.addEventListener("click", () => {
            _NewsDetail.open(item.newsId);
        });
        listEl.appendChild(a);
    });
};

const drawTotalCount = function (count) {
    const strong = document.querySelector(".tabArea .contents > .total strong");
    if (strong) strong.textContent = count ?? 0;
};

const initSearchEvent = function () {
    const searchInput = document.querySelector(".search-box input[type='search']");
    const searchBtn = document.querySelector(".search-box button");

    if (!searchInput || !searchBtn) return;

    searchBtn.addEventListener("click", function () {
        const keyword = searchInput.value.trim();
        SEARCH.searchValue = keyword;

        drawList(1);
    });

    searchInput.addEventListener("keypress", function (e) {
        if (e.key === "Enter") {
            searchBtn.click();
        }
    });
};